import React from 'react';
import { Box, Typography, Skeleton, Divider, Grid, LinearProgress } from '@mui/material';

const SkeletonSummaryCard = () => (
  <Box
    sx={{
      p: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      transition: 'transform 0.3s',
      '&:hover': { transform: 'scale(1.01)' },
      border: '1px solid #e0e0e0',
      borderRadius: 2,
      mb: 2,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Skeleton variant="circular" width={40} height={40} />
      <Box sx={{ ml: 2 }}>
        <Skeleton variant="text" width={80} />
        <Skeleton variant="text" width={60} />
      </Box>
    </Box>
    <Skeleton variant="text" width={20} />
  </Box>
);

const SkeletonProfileStrength = () => (
  <Box sx={{ p: 3, mb: 3, borderRadius: 2, width: '100%' }}>
    <Typography variant="h6" sx={{ mb: 2 }}>
      <Skeleton width="30%" />
    </Typography>
    <Divider sx={{ my: 3 }} />
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
      <LinearProgress
        variant="determinate"
        value={0}
        sx={{
          width: '100%',
          mr: 2,
          height: 10,
          borderRadius: 5,
        }}
      />
      <Skeleton variant="text" width={40} height={40} />
    </Box>
    <Typography variant="h6" sx={{ mb: 2 }}>
      <Skeleton width="30%" />
    </Typography>
    <Divider sx={{ my: 3 }} />
    <Grid container spacing={2}>
      {[...Array(4)].map((_, index) => (
        <Grid item xs={12} key={index}>
          <SkeletonSummaryCard />
        </Grid>
      ))}
    </Grid>
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        <Skeleton width="30%" />
      </Typography>
      <Skeleton variant="rectangular" width="100%" height={350} sx={{ mt: 2 }} />
    </Box>
  </Box>
);

export default SkeletonProfileStrength;
